import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Standard from './Standard'

class Equal extends React.Component {
  static propTypes = {
    validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    validtext: PropTypes.string,
  }

  static defaultProps = {
    validations: {},
    validtext: '',
  }

  render = () => {
    const { validations, validtext, ...other } = this.props

    return (
      <Standard
        validations={merge({}, validations, { isEqual: validtext })}
        {...other}
      />
    )
  }
}

export default Equal
